import toInteger from '../toInteger';

export default function isNumber(value){
  return !isNaN(toInteger(value));
}
